export default __webpack_public_path__ + "static/media/volkihar-enderal.94e15b2e.jpg";